import { render, staticRenderFns } from "./pictrueTextMsg.vue?vue&type=template&id=e2e2b890&scoped=true"
import script from "./pictrueTextMsg.vue?vue&type=script&lang=js"
export * from "./pictrueTextMsg.vue?vue&type=script&lang=js"
import style0 from "./pictrueTextMsg.vue?vue&type=style&index=0&id=e2e2b890&prod&lang=scss"
import style1 from "./pictrueTextMsg.vue?vue&type=style&index=1&id=e2e2b890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e2b890",
  null
  
)

export default component.exports